import React from 'react';
import { coach } from '../../config/coach';

const Marquee = () => {
  const items = [...coach.marquee, ...coach.marquee];
  return (
    <section className="relative bg-black border-y border-white/10 py-8 sm:py-10 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        {items.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-stroke text-5xl sm:text-7xl tracking-tight px-6 sm:px-10 select-none">
              {word}
            </span>
            <span className="text-white/25 text-2xl sm:text-4xl select-none">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
